const Notifier = {
  listioners: {},
  subscribe: function (type, callback) {
    if (!this.listioners[type]) {
      this.listioners[type] = [];
    }
    this.listioners[type].push(callback);
    // return function to unsubscribe
    return function() {
      Notifier.listioners[type].splice(Notifier.listioners[type].indexOf(callback), 1);
    };
  },
  notify: function (type, data) {
    if (this.listioners[type]) {
      this.listioners[type].forEach((callback) => {
        callback(data);
      });
    }
  },
};
export default Notifier;
